import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { imageEditorActions } from "../../../store/imageEditor";
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import { Button } from "@mui/material";

export async function invertMask(mask) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = mask;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];
        if (alpha === 0) {
          // transparent → opaque white
          data[i] = 255;
          data[i + 1] = 255;
          data[i + 2] = 255;
          data[i + 3] = 255;
        } else {
          // opaque → transparent
          data[i + 3] = 0;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      const invertedBase64 = canvas.toDataURL("image/png");
      resolve(invertedBase64);
    };
  });
}

export default function InvertMaskButton() {

  const dispatch = useDispatch();

  const mask = useSelector((state) => state.imageEditor.mask);

  const invertMaskBase64 = async () => {
    const inverted = await invertMask(mask);
    dispatch(imageEditorActions.setMask(inverted));
  }

  return (
    <Button
      variant="outlined"
      onClick={invertMaskBase64}
      startIcon={<InvertColorsIcon />}
    >
      Invert Mask
    </Button>
  );
}
